import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as dependentActions from "../redux/actions/dependentActions";
import * as userDetailActions from "../redux/actions/userDetailActions";
import AddNewDependentComponent from "../components/AddNewDependentComponent";
import A12Y_CONST from "../common/a12yConst";
import { secureClient } from "../config/axiosClient";
import LoaderFullScreen from "../components/LoaderFullScreenComponent";

class AddNewDependentScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      errorMessage: "",
      // initialLoading: true,
    };
  }

  // componentDidMount = async () => {
  //   const advocateId = this.props.userState?.userInfo?.advocate_id || this.props.userState?.userInfo?.id;
  //   if (advocateId) {
  //     this.setState({ initialLoading: true });
  //     try {
  //       const subDetails = this.props.userSubscriptionAllDetails;
  //       const isTrialing = subDetails?.trial_period === true && 
  //         (subDetails?.status?.toLowerCase() === 'trialing' || 
  //          subDetails?.subscription_details?.subscription_status?.toLowerCase() === 'trialing');

  //       const apiCalls = [
  //         this.props.getSubscription(),
  //         this.props.getAllDependent(advocateId)
  //       ];

  //       if (!isTrialing) {
  //         apiCalls.push(this.props.getProration());
  //       }

  //       await Promise.all(apiCalls);
  //     } catch (err) {
  //       console.error("Error loading billing details on mount:", err);
  //     } finally {
  //       this.setState({ initialLoading: false });
  //     }
  //   } else {
  //     this.setState({ initialLoading: false });
  //   }
  // };

  handleCancel = () => {
    this.props.history.push(A12Y_CONST.ROUTE.DASHBOARD2);
  };

  // API expects dob as MM/DD/YYYY
  formatDob = (dateStr) => {
    if (!dateStr) return null;
    const [month, day, year] = dateStr.split("/");
    return `${month}/${day}/${year}`;
  };

  // API expects appointment_date as MM/DD/YYYY
  formatAppointmentDate = (dateStr) => {
    if (!dateStr) return null;
    const [month, day, year] = dateStr.split("/");
    return `${month}/${day}/${year}`;
  };

  handleSubmit = async (formData, avatarFile) => {
    this.setState({ loading: true, error: false, errorMessage: "" });

    try {
      // 1. Create the dependent via Redux action
      const advocateId = this.props.userState?.userInfo?.advocate_id || this.props.userState?.userInfo?.id;
      const createdDependent = await this.props.createDependent(
        advocateId,
        {
          first_name: formData.first_name,
          last_name: formData.last_name,
          nick_name: formData.nick_name,
          dob: this.formatDob(formData.dob),
          gender: formData.gender,
          email: formData.email ? JSON.parse(formData.email) : null,
          phone: formData.phone ? JSON.parse(formData.phone) : [],
          appointment_date: this.formatAppointmentDate(formData.appointment_date || formData.court_date),
          case_file_num: formData.case_file_number,
          advocord_ref_id: formData.advocord_ref_id,
          county: formData.county,
          billing_rate: formData.billing_rate,
        }
      );

      if (this.props.isError || (createdDependent && createdDependent.error)) {
        this.setState({
          loading: false,
          error: true,
          errorMessage: (createdDependent && createdDependent.errMsg) || this.props.errMsg || A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
        });
        return;
      }

      // 3. If avatar provided, upload it
      if (avatarFile && createdDependent?.id) {
        try {
          const { uploadImage } = require('../util/imageUpload');
          const objectUrl = URL.createObjectURL(avatarFile);
          await uploadImage(avatarFile, advocateId, createdDependent.id, objectUrl, createdDependent);
          URL.revokeObjectURL(objectUrl);
        } catch (error) {
          // Non-fatal: avatar upload failure shouldn't block navigation
          console.error('error in avatar upload', error);
        }
      }

      this.setState({ loading: false });
      // 4. Refresh global dependent list so popup/dashboard has latest data
      await this.props.getSubscription();
      // await this.props.getAllDependent(advocateId);

      // Navigate back to the dependents dashboard on success
      await this.props.setIsFetchDependnet(true);
      this.props.history.push(A12Y_CONST.ROUTE.DASHBOARD2);

    } catch (e) {
      this.setState({
        loading: false,
        error: true,
        errorMessage: A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
      });
    }
  };

  render() {
    if (this.state.initialLoading) {
      return (
        <div className="myProfileAccount animationall mainRightSidebare">
          <div className="rightPanelWidhtSidebar">
            <div className="rightPanelWidhtSidebarContainer fullWidth">
              <LoaderFullScreen />
            </div>
          </div>
        </div>
      );
    }

    const allDependentList = this.props.dependentList || [];
    const subscription = this.props.subscription || [];
    const allActiveDependent = allDependentList.filter(d => d.status === 0);

    // Calculate total quantity from active subscriptions
    const totalQuantity = (Array.isArray(subscription) ? subscription : [])
      .filter(s => s.status === "active" || s.status === "trialing")
      .reduce((acc, sub) => {
        const subQty = sub.items?.reduce((iAcc, item) => iAcc + (item.quantity || 0), 0) || 0;
        return acc + subQty;
      }, 0);

    const isTrialing = (Array.isArray(subscription) ? subscription : []).some(s => s.status === "trialing");
    const isQuotaFull = isTrialing ? false : (allActiveDependent.length >= totalQuantity);

    const subDetails = this.props.userSubscriptionAllDetails || {};
    const subStatus = subDetails.cancel_at_period_end
      ? "CANCELLED"
      : (subDetails.status || subDetails.subscription_details?.subscription_status);
    const isTrialExpired = subDetails.is_trial_expired;

    return (
      <div className="myProfileAccount animationall mainRightSidebare">
        <div className="rightPanelWidhtSidebar">
          <div className="rightPanelWidhtSidebarContainer fullWidth">
            <AddNewDependentComponent
              onSubmit={this.handleSubmit}
              onCancel={this.handleCancel}
              loading={this.state.loading}
              error={this.state.error}
              errorMessage={this.state.errorMessage}
              isQuotaFull={isQuotaFull}
              totalAllowed={totalQuantity}
              currentCount={allActiveDependent.length}
              subscription={this.props.userSubscriptionAllDetails}
              subscriptionType={subStatus}
              isTrialExpired={isTrialExpired}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userState: state.userDetailReducer.userState,
  dependent: state.dependentReducer.dependent,
  dependentList: state.dependentReducer.dependentList,
  subscription: state.userDetailReducer.subscription,
  userSubscriptionAllDetails: state.userDetailReducer.userSubscriptionAllDetails,
  errMsg: state.dependentReducer.errMsg,
  isError: state.dependentReducer.isError,
  isFetchDependnet: state.dependentReducer.isFetchDependnet,
});

const mapDispatchToProps = (dispatch) => ({
  createDependent: (advocate_id, data) =>
    dispatch(dependentActions.createDependent(advocate_id, data)),
  createAddress: (advocate_id, dependent_id, data) =>
    dispatch(dependentActions.createAddress(advocate_id, dependent_id, data)),
  getAllDependent: (advocate_id) =>
    dispatch(dependentActions.getAllDependent(advocate_id)),
  getSubscription: () =>
    dispatch(userDetailActions.getSubscription()),
  getProration: () =>
    dispatch(userDetailActions.getProration()),
  sendErrorReportToServer: (type, error) =>
    dispatch(userDetailActions.sendErrorReportToServer(type, error)),
  setIsFetchDependnet: (status) => dispatch(dependentActions.setIsFetchDependnet(status)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddNewDependentScreen)
);
